<sh-datepicker
    [label]="label()"
    [attr.format]="format() ?? null"
    [attr.separator]="separator() ?? null"
    [attr.months]="months() ?? null"
    [range]="range()"
    [futureDateDisable]="futureDateDisable()"
    [pastDateDisable]="pastDateDisable()"
    [condensed]="condensed()"
    [editable]="editable()"
    [attr.responsive]="responsive() ?? null"
    [attr.scrollpicker]="scrollpicker() ?? null"
    [readonly]="readonly()"
    [error]="error()"
    [success]="success()"
    [safety]="safety()"
    [attr.hint]="hint() ?? null"
    [attr.errorMessage]="errorMessage() ?? null"
    [noBorder]="noBorder()"
    [mandatory]="mandatory()"
    [attr.max]="max() ?? null"
    [attr.min]="min() ?? null"
    [noClear]="noClear()"
    [requireApply]="requireApply()"
    [attr.locale]="locale() ?? null"
    [disabled]="disabled || disabledInput()"
    [value]="value()"
    (value-changed)="handleValueChanged($event)"
    (blur)="handleBlur()"
></sh-datepicker>
